type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description: string;
  id?: string;
};

export default function SectionHeading({ eyebrow, title, description, id }: SectionHeadingProps) {
  return (
    <div id={id} className="max-w-3xl">
      <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-accent-600 uppercase">
        <span className="w-6 h-px bg-accent-500"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">{title}</h2>
      <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">{description}</p>
    </div>
  );
}